import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";

export default function DropzoneUploader(props) {
  const [fileNames, setFileNames] = useState([]);

  useEffect(() => {
    props.onChange && props.onChange(fileNames);
  }, [fileNames]);

  const handleDrop = acceptedFiles =>
    setFileNames(acceptedFiles.map(file => file));

  return (
    <div className="App">
      <Dropzone accept={props.accept} onDrop={handleDrop} maxFiles={props.maxFiles || 1}>
        {({ getRootProps, getInputProps }) => (
          <div {...getRootProps({ className: `dropzone ${props.error ? "dropzone-error" : ""}` })}>
            <input {...getInputProps()} />
            <p>Drag'n'drop files, or click to select files</p>
          </div>
        )}
      </Dropzone>
      <div>
        <ul>
          {fileNames.map(file => (
            <li key={file.name}>{file.name}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

DropzoneUploader.defaultProps = {
  accept: "application/vnd.ms-excel"
}